/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import i18n from './i18n';
import { useAppSelector } from 'pages/thermography/config/store';

const toI18nLocale = (locale: any) => (locale === 'en' ? 'en' : 'pt-br');

export default function I18nLocaleSync() {
    const locale = useAppSelector(state => (state as any).locale?.currentLocale ?? (state as any).locale);

    useEffect(() => {
        if (!locale) return;
        const next = toI18nLocale(locale);
        if (i18n.language !== next) i18n.changeLanguage(next);
    }, [locale]);

    return null;
}
